"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Visibility_1 = __importDefault(require("@mui/icons-material/Visibility"));
const VisibilityOff_1 = __importDefault(require("@mui/icons-material/VisibilityOff"));
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const icon_button_1 = require("./icon-button");
exports.PasswordField = (0, react_2.memo)((props) => {
    const [showPassword, setShowPassword] = react_1.default.useState(false);
    const [value, setValue] = (0, react_1.useState)();
    const theme = (0, material_1.useTheme)();
    (0, react_1.useEffect)(() => {
        setValue(value);
    }, [props.value, value]);
    const handleShowPassword = react_1.default.useCallback(() => {
        setShowPassword((prev) => !prev);
    }, []);
    const onChange = (0, react_1.useCallback)((ev) => {
        var _a;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, ev);
        setValue(ev.target.value);
    }, [props]);
    return ((0, jsx_runtime_1.jsx)(material_1.TextField, Object.assign({}, props, { type: showPassword ? "text" : "password", onChange: onChange, slotProps: {
            input: {
                endAdornment: props.value ? ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", children: (0, jsx_runtime_1.jsx)(icon_button_1.IconButton, { "aria-label": showPassword ? "hide the password" : "display the password", onClick: handleShowPassword, edge: "end", children: !showPassword ? ((0, jsx_runtime_1.jsx)(VisibilityOff_1.default, { sx: {
                                fontSize: theme.typography.body1.fontSize,
                                color: theme.palette.text.secondary,
                            } })) : ((0, jsx_runtime_1.jsx)(Visibility_1.default, { sx: {
                                fontSize: theme.typography.body1.fontSize,
                                color: theme.palette.text.secondary,
                            } })) }) })) : null,
            },
        } })));
});
exports.PasswordField.displayName = "PasswordField";
